import { either } from "fp-ts";
import { CasesPageView, TCasesPageView } from "../../../../domain/codecs/form/CasesForm";

export const CASES_PAGE_VIEW_STORAGE_KEY = "cases_page_view";

export const decodeStoredCasesPageView = (stored: string | null): TCasesPageView | undefined => {
    if (stored === null) {
        return undefined;
    }
    const decoded = CasesPageView.decode(stored);
    return either.isRight(decoded) ? decoded.right : undefined;
};

export const resolveCasesLandingView = (
    hasCaseDeepLinkParams: boolean,
    persistedView: TCasesPageView | undefined,
): TCasesPageView =>
    hasCaseDeepLinkParams
        ? "case"
        : persistedView ?? "day";

export const getPersistedCasesPageView = (): TCasesPageView | undefined =>
    decodeStoredCasesPageView(localStorage.getItem(CASES_PAGE_VIEW_STORAGE_KEY));

export const setPersistedCasesPageView = (view: TCasesPageView): void =>
    localStorage.setItem(CASES_PAGE_VIEW_STORAGE_KEY, view);
